export const CATEGORY_LABELS = {
  faq: "FAQ",
  script: "Script",
  policy: "Política",
  product: "Produto",
  other: "Outro",
};

export const INDEX_STATUS_LABELS = {
  pending: "Não indexado",
  indexing: "Indexando…",
  indexed: "Indexado",
  error: "Erro",
};

export const INDEX_STATUS_TONE = {
  pending: "warning",
  indexing: "info",
  indexed: "success",
  error: "danger",
};
